module.exports = __webpack_public_path__ + "img/handphone.5a9dc498.png";